
import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { Language } from "@/models/Language";
import { AxiosError, AxiosResponse } from "axios";
import api from "../../network/api";
import moment from "moment";
import WorkShopType from "../../models/WorkshopType";
import { mixins } from "vue-class-component";
import DeviceType from "../../utils/DeviceUtil";

@Component
export default class Workshop extends mixins(DeviceType) {
  @Getter("userLanguageId") private currentLanguage!: Language;

  private current: Array<WorkShopType> = [];
  private upcomings: Array<WorkShopType> = [];
  private finished: Array<WorkShopType> = [];
  private selected: WorkShopType = {};
  public countdown = 0;
  private schedualTab = true;
  private detailsTab = false;
  Ready = false;

  get selectedDate() {
    const date = moment(this.selected.date);
    const day = `${this.$i18n.t(date.format("dddd"))}`;
    const month = `${this.$i18n.t(date.format("MMM"))}`;
    return `${day} ${date.format("DD")} ${month} ${date.format("YYYY")}`;
  }
  created() {
    api.get("workshops").then(
      (response: AxiosResponse) => {
        this.current = response.data.current ?? [];
        this.upcomings = response.data.upcoming;
        this.finished = response.data.finished;
        // set the selected to the first available current or finished or upcoming
        this.selected =
          this.current.length > 0
            ? this.current[0]
            : this.upcomings.length > 0
            ? this.upcomings[0]
            : this.finished.length > 0
            ? this.finished[0]
            : {};

        if (this.upcomings != null && this.upcomings.length > 0) {
          const nextDate = this.upcomings[0].date;
          const nextStartTime = this.upcomings[0].from;

          const nextDateTime = moment.utc(
            nextDate + " " + nextStartTime,
            "YYYY-MM-DD hh:mm:ss"
          );
          const now = moment.utc();
          const secondsToEvent = nextDateTime.diff(now, "seconds");

          this.countdown = secondsToEvent;

          setInterval(() => {
            this.countdown--;
            if (this.countdown == 0) {
              location.reload();
            }
          }, 1000);
        }
        this.Ready = true;
      },
      (error: AxiosError) => {
        this.current = [];
        this.upcomings = [];
        this.selected = {};
        this.finished = [];
      }
    );
  }

  gohome() {
    this.$router.push("/");
  }

  setSelectedWorkshop(selectedWorkshop: WorkShopType) {
    this.selected = selectedWorkshop;
    if (this.isMobile || this.isTablet || this.isMediumScreen) {
      this.schedualTab = false;
      this.detailsTab = true;
    }
  }
  attendWorkshop() {
    // Validates workshop in progress
    if (this.current.some(workshop => workshop.id === this.selected.id)) {
      api.post(`workshops/${this.selected.id}/attend`);
    }
  }
}
